<template>
  <div>
    <survey-summary
      :survey="buffer"
      :isSimulation="false"
      :isSurvey="false"
      :commutesActive="commutesActive"
      :foodsActive="foodsActive"
      :year="year"
    />
    <br />
    <b-notification :closable="false">
      <b-field :label="$t('compCarbonFormsSurveyConfirmationForm.comment')">
        <b-input
          type="textarea"
          @input="$emit('input', buffer)"
          maxlength="500"
          expanded
          :placeholder="$t('compCarbonFormsSurveyConfirmationForm.comment')"
          v-model="buffer.message"
        />
      </b-field>
    </b-notification>
    <br />
    <div class="columns">
      <div class="column">
        <button class="button is-fullwidth" @click="$emit('edit')">
          <span class="icon is-small"><i class="fa fa-arrow-left"></i></span>
          <span>{{ $t('compCarbonFormsSurveyConfirmationForm.edit') }}</span>
        </button>
      </div>
      <div class="column">
        <button class="button is-fullwidth is-primary" @click="$emit('submit')">
          <span class="icon is-small"><i class="fa fa-paper-plane"></i></span>
          <span>{{ $t('submit') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationForm',
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    },
    commutesActive: {
      type: Boolean,
      default: false
    },
    foodsActive: {
      type: Boolean,
      default: false
    },
    year: {
      type: Number,
      default: null
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'survey-summary': () =>
      import('@/components/carbon/forms/survey/Summary.vue')
  },
  data () {
    return {
      buffer: Object.assign({}, this.value)
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = Object.assign({}, this.value)
      },
      deep: true
    }
  }
}
</script>
